export default __webpack_public_path__ + "static/media/mallory_mp_compact_medium.132bdebc.ttf";